import axios from '../axios'
import { errorMessage, fieldErrors } from './FollowupService'

/**
 * Batch 5, Warnings & Approvals: the settings page, the warning log and "Run scan now".
 * All Admin only. The on-save value check (any signed-in user) is QuotationService.quoteAnomalyCheck.
 *
 * A refusal is a 409 `{ error }`, never a 403 (the global axios interceptor signs the user out on any 403);
 * a bad value is a 400 `{ error }` or `{ errors: { field: message } }`. `errorMessage(err)` turns either into one line.
 */
export default class WarningsService {
  /** The settings, the Admin approvers and the active users for the pickers. */
  getSettings() {
    return this._send('get', '/v1/warningSettings')
  }

  /** Partial update, all-or-nothing; answers with the same body as getSettings. */
  saveSettings(settings) {
    return this._send('put', '/v1/warningSettings', settings)
  }

  /** The log, newest first (at most 1000). `from` / `to` are yyyy-MM-dd; `check` a check code. All optional. */
  getWarnings({ from, to, check } = {}) {
    var params = {}
    if (from) params.from = from
    if (to) params.to = to
    if (check) params.check = check
    return this._send('get', '/v1/anomalyWarnings', undefined, { params: params })
  }

  /** Runs the nightly scan now: `{ found, logged, emailed }`. */
  runScan() {
    return this._send('post', '/v1/anomalyScan/run')
  }

  _send(method, path, body, config) {
    return new Promise(async function (resolve, reject) {
      try {
        var response
        if (method === 'get') response = await axios.get(path, config)
        else response = body === undefined ? await axios[method](path) : await axios[method](path, body)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}

export { errorMessage, fieldErrors }
